// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './pages/layout/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import CodeOtp from './pages/CodeOtp';
import Verifikasi from './pages/Verifikasi';
import Dashboard from './pages/Dashboard';
import Welcome from './pages/Welcome';
import UserList from './pages/users/List';
import WorkGroup from './pages/group/WorkGroup';
import WorkOrder from './pages/wo/WorkOrder';
import WorkOrderDetail from './pages/wo/WorkOrderDetail';
import WorkOrderProgress from './pages/wo/WorkOrderProgress';
import WorkOrderDone from './pages/wo/WorkOrderDone';
import WorkOrderClosed from './pages/wo/WorkOrderClosed';
import Penugasan from './pages/wo/Penugasan';
import PenugasanDetail from './pages/wo/PenugasanDetail';
import LaporanContactCenter from './pages/laporan/LaporanContactCenter';
import LaporanHandlingTime from './pages/laporan/LaporanHandlingTime';
import LaporanJenisPengaduan from './pages/laporan/LaporanJenisPengaduan';
import LaporanRekapitulasi from './pages/laporan/LaporanRekapitulasi';
import ProtectedRoute from './pages/components/ProtectedRoute';

// CSS
import './assets/css/bootstrap.css';
import './assets/vendors/chartjs/Chart.min.css';
import './assets/vendors/perfect-scrollbar/perfect-scrollbar.css';
import './assets/css/app.css';

// JS
import './assets/js/main.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return (
    <Router>
      <Routes>
        {/* Halaman tanpa layout */}
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/CodeOtp" element={<CodeOtp />} />
        <Route path="/Verifikasi" element={<Verifikasi />} />

        {/* Halaman dengan layout (wajib login) */}
        <Route
          path="/Dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Welcome"
          element={
            <ProtectedRoute>
              <Layout>
                <Welcome />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Users/List"
          element={
            <ProtectedRoute>
              <Layout>
                <UserList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Group/WorkGroup"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkGroup />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/WorkOrder"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkOrder />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/WorkOrderDetail/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkOrderDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/WorkOrderProgress/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkOrderProgress />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/Penugasan"
          element={
            <ProtectedRoute>
              <Layout>
                <Penugasan />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/PenugasanDetail/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <PenugasanDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/WorkOrderDone/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkOrderDone />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Wo/WorkOrderClosed/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkOrderClosed />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Laporan/LaporanContactCenter"
          element={
            <ProtectedRoute>
              <Layout>
                <LaporanContactCenter />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Laporan/LaporanHandlingTime"
          element={
            <ProtectedRoute>
              <Layout>
                <LaporanHandlingTime />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Laporan/LaporanJenisPengaduan"
          element={
            <ProtectedRoute>
              <Layout>
                <LaporanJenisPengaduan />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Laporan/LaporanRekapitulasi"
          element={
            <ProtectedRoute>
              <Layout>
                <LaporanRekapitulasi />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
